// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3eWpv","content":"LoadingAlert_content__2thnG"};